import React from 'react';

import { UploadField } from './UploadField';

export const UploadScreen: React.FC = () => {
  return <UploadField />;
};
